import { UnifiedInvoicesCard } from "./components/unified-invoices-card";

function formatDate(dateString?: string | null) {
  if (!dateString) {
    return "—";
  }
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function formatCurrency(amount: string, currency = "USD") {
  const numericAmount = Number(amount);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(numericAmount);
}

export const InvoicesPage = () => (
  <div className="mx-auto">
    <UnifiedInvoicesCard
      formatCurrency={formatCurrency}
      formatDate={formatDate}
    />
  </div>
);
